module.exports = __webpack_public_path__ + "static/1-bf963b76a03fd7d9010d1920a14756b1.jpg";